module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAcCAMAAAC02HQrAAAAAXNSR0IB2cksfwAAAEVQTFRFAAAA////////////////////////////////////////////////////////////////////////////////////////Up1zwgAAABd0Uk5TACBvv+//gH8Qz9BwsEDA8DDgrz+QYKBOMROJAAAApklEQVR4nG2R0RaEIAgFsdK1FM22+v9P3QI0tZ2XaI7iFQFu1DBOehoHBQWjMx8xdtYPsyW36Jq53ciYq73uUeC48AjouXQQWFFnlgEifVdySPUEvF5iyU96rUvSbyMXpJ+cu30Bt3yufeW7brd3ar9HEBsVaQiucY5TpUolSYqVwzznUJQvs3/m9edBzKNyHs6ROcgd0LDQ5VuwzpE59dkrUKnk+AFkCQi3n2MRowAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/search-gps-active@2x.png
// module id = 902
// module chunks = 0